import React, { useState } from "react";
import "./App.css";

function App() {
  const [file, setFile] = useState(null);
  const [preview, setPreview] = useState(null);
  const [result, setResult] = useState(null);
  const [loading, setLoading] = useState(false);

  const handleFileChange = (e) => {
    const selectedFile = e.target.files[0];
    setFile(selectedFile);
    setPreview(URL.createObjectURL(selectedFile));
    setResult(null);
  };

  const handleSubmit = async () => {
    if (!file) return;

    const formData = new FormData();
    formData.append("file", file);

    setLoading(true);

    try {
      const response = await fetch("https://backend-potato-disease-leaf.onrender.com/predict", {
        method: "POST",
        body: formData,
      });

      const data = await response.json();
      setResult(data);
    } catch (error) {
      alert("Prediction failed. Is the backend running?");
    }

    setLoading(false);
  };

  return (
    <div className="app-container">
      <div className="card">
        <h1>🥔 Potato Disease Prediction</h1>

        <input
          type="file"
          accept="image/*"
          onChange={handleFileChange}
          className="file-input"
        />

        {preview && (
          <img src={preview} alt="preview" className="image-preview" />
        )}

        <button onClick={handleSubmit} disabled={loading}>
          {loading ? "Predicting..." : "Predict"}
        </button>

        {result && (
          <div className="result">
            <h3>Prediction</h3>
            <p><strong>Disease:</strong> {result.prediction}</p>
            <p><strong>Confidence:</strong> {result.confidence}%</p>
          </div>
        )}
      </div>
    </div>
  );
}

export default App;